import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

export const orderRefillsQueryKey = ['portal-order-refills'] as const

/** Loads medications available for reordering now or after a cooldown within prescription validity. */
export function useListOrderRefills(enabled: boolean) {
  const api = usePortalApi()
  return useQuery({
    queryKey: orderRefillsQueryKey,
    enabled,
    queryFn: async () => dataOrThrow(await api.get('/orders/refill')),
  })
}
